import moment from 'moment'

export const isEmailValid = (email) =>
    email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)

export const isPasswordValid = (password) => {
    return password.length >= 8
}

let lastControlledChange = 0
export const onControlledChange = (text, limit, callback) => {
    setTimeout(() => {
        const now = new Date().getTime()
        if (
            now - lastControlledChange >= 500 &&
            (text.length > limit || text.length === 0)
        ) {
            callback(text)
        }
    }, 500)
    lastControlledChange = new Date().getTime()
}

export const chunk = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
    )
}

export const isEmpty = (arr) =>
    !arr || arr.length === 0 || Object.keys(arr).length === 0

export const isEmptyStr = (str) => str === '' || !str || str.length === 0

export const getArrayOfNum = (length) =>
    [...Array(length).keys()].map((i) => i + 1)

export const isArray = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Array]'
}

export const getEmptyStrIfNull = (obj) => {
    if (obj === null) {
        return ''
    } else return obj
}

export const formatDate = (date, format) => {
    if (!date) {
        return null
    }
    let d = date
    if (typeof date === 'object') {
        d = date.date
    }
    return moment(d).format(format)
}

export const dateForServer = (date) => Math.round(Date.parse(date) / 1000)

export const getStartOfDay = (date) =>
    moment(date).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
    })

export const getEndOfDay = (date) =>
    moment(date).set({
        hour: 24,
        minute: 59,
        second: 59,
        millisecond: 999,
    })
